
export function smoothScroll(el = window) {
    // const event = new Event('smoothScroll')
    window.ticking = false
    let orig = 0
    let delta = 0
    window.addEventListener('scroll', (evt) => {
        if (!window.ticking) {
            requestAnimationFrame(() => {
                // console.log('EVT: ', evt)
                delta = el.scrollTop - delta
                const customEvent = new CustomEvent('smoothScroll', {
                    detail: {
                        bounds: el.getBoundingClientRect(),
                        scrollTop: el.scrollTop,
                        delta,
                    }
                })
                delta = el.scrollTop
                window.dispatchEvent(customEvent)
                window.ticking = false
            })
        }
        window.ticking = true
    })
}
